import * as React from "react";

const SvgSpeakerphone = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={color}
      strokeWidth={2}
    >
      <path d="M11 4.882V18.24a1.76 1.76 0 0 1-3.417.592l-2.147-6.15M18 12a3 3 0 1 0 0-6" />
      <path d="M5.436 12.683A4.001 4.001 0 0 1 7 5h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 0 1-1.564-.317Z" />
    </g>
  </svg>
);

export default SvgSpeakerphone;
